import { TransferAppState } from '@wetransfer/ad-sdk';
import { TransferNavigateArgs } from '@wetransfer/adtech-common';

import Router from '@wetransfer/transfer/modules/router';
import Store from '@wetransfer/transfer/store';

import { getLanguage } from './override-helper';

export const openPanel = ({
  path,
  adId,
  trk,
  shouldTrack,
}: TransferNavigateArgs): void => {
  const state = Store.getState();
  const { route, session } = state;

  // Opens panel with given path.
  if (!path || !path.match(/^\/[a-z0-9]/)) return;

  // TODO: check if we have to support shouldTrack any longer
  // This will be removed when we know the new trkCode is working as expected,
  // it stays here in the meantime to not break older versions of it running
  const trkOriginal = trk ? { search: `trk=${trk}` } : {};

  const language = getLanguage(session, route);

  // So the url with the trk code will look like https://wetransfer.com/pro?trk=wp_000000_us_en
  const trkCode = `wp_${adId}_${language}_${path.replace('/', '')}`;

  const params =
    shouldTrack && typeof shouldTrack === 'boolean'
      ? { search: `trk=${trkCode}` }
      : trkOriginal;

  Router.navigateTo(path, false, params);
};

export const isDirectOrTestLink = (
  route: TransferAppState['route']
): boolean => {
  const isDirectLink = Boolean(route.params?.advert_id);
  const isTestLink = Boolean(route.query?.ad_id);

  return isDirectLink || isTestLink;
};

export const closePanel = () => {
  Router.navigateTo(Router.getLastRoute('transfer', '/'));
};
